import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const weatherQueryKeys = {
  all: ['weather'],
  region: (regionCode) => [...weatherQueryKeys.all, 'region', regionCode],
  today: (regionCode, targetDateStr) => [...weatherQueryKeys.all, 'today', regionCode, targetDateStr],
};

// 날씨 조회 (6시간 예보)
export const useWeather = (regionCode, options = {}) => {
  // regionCode가 유효한 값인지 확인 (null, undefined, 빈 문자열 체크)
  const hasValidRegionCode = regionCode !== null && regionCode !== undefined && regionCode !== '';
  // enabled 옵션이 전달되면 그것도 확인하되, regionCode가 유효해야 함
  const isEnabled = hasValidRegionCode && (options.enabled !== undefined ? options.enabled : true);
  
  // options에서 enabled를 제거하고 나중에 덮어쓰기
  const { enabled: _, ...restOptions } = options;
  
  return useQuery({
    queryKey: weatherQueryKeys.region(regionCode),
    queryFn: () => {
      if (!hasValidRegionCode) {
        throw new Error('Invalid regionCode');
      }
      return api.get(`/drivecore/weather/api/RegionWeather/SixHoursForecast/${regionCode}`);
    },
    ...restOptions,
    enabled: isEnabled, // regionCode가 유효할 때만 요청 (나중에 설정하여 덮어쓰기)
  });
};

// 날씨 조회 (금일 24시간 누적)
export const useWeatherToday = (regionCode, targetDateStr = null, options = {}) => {
  // regionCode가 유효한 값인지 확인 (null, undefined, 빈 문자열 체크)
  const hasValidRegionCode = regionCode !== null && regionCode !== undefined && regionCode !== '';
  // enabled 옵션이 전달되면 그것도 확인하되, regionCode가 유효해야 함
  const isEnabled = hasValidRegionCode && (options.enabled !== undefined ? options.enabled : true);
  
  // options에서 enabled를 제거하고 나중에 덮어쓰기
  const { enabled: _, ...restOptions } = options;
  
  return useQuery({
    queryKey: weatherQueryKeys.today(regionCode, targetDateStr),
    queryFn: () => {
      if (!hasValidRegionCode) {
        throw new Error('Invalid regionCode');
      }
      return api.get(`/drivecore/weather/api/RegionWeather/${regionCode}`, { params: { targetDateStr } });
    },
    ...restOptions,
    enabled: isEnabled, // regionCode가 유효할 때만 요청 (나중에 설정하여 덮어쓰기)
  });
};